import requests from "./api/base-api";

const Currency = {
    getMyCurrency: (params) => requests.getByParams(`/currency/v1/get-all-currency`, params),
    getChartData: (params) => requests.getByParams(`/currency/v1/get-chart-data`, params),
    getAll: (params) => requests.getByParams('/currency/v1/user-get-all-currency-Name', params),
    addSymbol: (data) => requests.patch('/user/v1/save-symbols', data)
};

export default Currency;